import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'react-admin';
import {
    CONFIRMED_MONITORING,
    SHOW_NOTIFICATION,
    CONFIRM_MONITORING_NUMBER_FAILURE,
    GET_FLIGHT_INFO_FAILURE,
    GET_FLIGHT_INFO_SUCCESS,
    REVIEW_FLIGHT_REQUEST_FAILURE,
    CREATE_FLIGHT_REQUEST_FAILURE,
    UPDATE_MONITORING_FILE_FAILURE,
    UPDATE_MONITORING_FILE_SUCCESS
} from './types';
import { SAVE_FLIGHT_REQUEST_FAILURE, GET_FLIGHT_REQUEST_FAILURE } from "../FlightRequestDetails/types"
import { clearSaveFlightRequest, clearFlightRequest as clearGetFlightRequest, getFlightRequest } from "../FlightRequestDetails/actions"
import { clearReviewFlightRequest, clearFlightRequest } from "./actions"
import { REESTABLISH_REQUEST_FAILURE } from "../FlightRestablish/types"
import { clearReEstablishRequest } from "../FlightRestablish/actions"
import { TIME_CHANGE_REQUEST_FAILURE } from "../FlightTimeChange/types"
import { clearTimeChangeRequest } from "../FlightTimeChange/actions"

function* showErrors(action: any) {
    if (action.payload.data.error) {
        yield put(showNotification(`ra.messages.${action.payload.data.error}`, 'error'));
    }
}

function* successfullOperation(action: any) {
    if (action.payload.data.success) {
        yield put(showNotification(`ra.messages.${action.payload.data.success}`, 'success'));
    } else {
        yield put(showNotification(`ra.messages.successfulOperation`, 'success'));
    }
}

/*function* showWarning(action: any) {
    if (action.payload.data.error) {
        yield put(showNotification(`ra.message.${action.payload.data.error}`, 'warning'));
    }
}*/

function* showMessage(action: any) {
    if (action.successMessage.message) {
        yield put(showNotification(action.successMessage.message, 'info'));
    }
}

function* getInternalServerError(action: any) {
    if (action.error && action.error === "Internal Server Error") {
        if (action.type === REVIEW_FLIGHT_REQUEST_FAILURE) {
            yield put(clearReviewFlightRequest());
        }
        if (action.type === CREATE_FLIGHT_REQUEST_FAILURE) {
            yield put(clearFlightRequest());
        }
        if (action.type === SAVE_FLIGHT_REQUEST_FAILURE) {
            yield put(clearSaveFlightRequest());
        }
        if (action.type === GET_FLIGHT_REQUEST_FAILURE) {
            yield put(clearGetFlightRequest());
        }
        if (action.type === REESTABLISH_REQUEST_FAILURE) {
            yield put(clearReEstablishRequest());
        }
        if (action.type === TIME_CHANGE_REQUEST_FAILURE) {
            yield put(clearTimeChangeRequest());
        }
    }
}

function* updateMonitoringFile(action: any) {
    if (action.payload.error) {
        yield put(showNotification('ra.messages.failedOperation', 'error'));
    } else {
        yield put(showNotification('ra.messages.successfulOperation', 'success'));
        yield put(getFlightRequest(action.requestPayload.data.id));
    }
}

export default function* flightRequestSaga() {
    yield takeEvery(CONFIRMED_MONITORING, showMessage);
    yield takeEvery(SHOW_NOTIFICATION, showMessage);
    yield takeEvery(CONFIRM_MONITORING_NUMBER_FAILURE, showErrors);
    yield takeEvery(GET_FLIGHT_INFO_FAILURE, showErrors);
    yield takeEvery(GET_FLIGHT_INFO_SUCCESS, successfullOperation);
    yield takeEvery([
        REESTABLISH_REQUEST_FAILURE,
        REVIEW_FLIGHT_REQUEST_FAILURE,
        CREATE_FLIGHT_REQUEST_FAILURE,
        SAVE_FLIGHT_REQUEST_FAILURE,
        GET_FLIGHT_REQUEST_FAILURE,
        TIME_CHANGE_REQUEST_FAILURE
    ], getInternalServerError);
    yield takeEvery([UPDATE_MONITORING_FILE_SUCCESS, UPDATE_MONITORING_FILE_FAILURE], updateMonitoringFile)
}